// Allow-list de acesso ao módulo "Meu Trabalho" (mywork).
//
// Decisões canônicas ee013ee6 / f89c881e: módulo B2B white-label — genérico
// por construção, sem nome de parceiro em lugar nenhum (nome, texto, ícone,
// comentário). O acesso nasce por e-mail para o piloto e cresce adicionando
// linhas aqui; num futuro com vínculo de organização, este arquivo é o único
// ponto a trocar.
//
// O gate de UI vive em useModules (card) + MyWork.tsx (rota) via
// useMyWorkAccess. A camada de DADO não depende disto: work_checkins tem RLS
// own-row e trigger de carimbo — a allow-list decide só quem VÊ a tela.

// Pilot paused by Rafael on 2026-09-30. Retain the original allowlist for a possible return.
export const MYWORK_ENABLED = false;
export const MYWORK_ALLOWLIST = ["82rmartins@gmail.com"];

// IDs de módulos gateados por allow-list — INVISÍVEIS para o público geral.
// Consumido pelo pino do card Free (pricingParity.test.ts): o número de
// módulos que o card anuncia fala com o PÚBLICO, então não conta estes ids.
// O pino em myWorkAccess.test.ts garante que todo id daqui existe no registry.
export const ALLOWLIST_GATED_MODULE_IDS = ["mywork"] as const;

export function isMyWorkAllowed(email?: string | null): boolean {
  if (!MYWORK_ENABLED || !email) return false;
  const normalized = email.trim().toLowerCase();
  if (!normalized) return false;
  return MYWORK_ALLOWLIST.some(
    (allowed) => allowed.trim().toLowerCase() === normalized,
  );
}
